import React, { useEffect } from 'react';
import { hot } from 'react-hot-loader';
import { connect } from 'react-redux';
import ZohoForm from '../../../hocs/ZohoForm/ZohoForm';
import { purifier, addEvent, removeEvent } from '../../../utils/dom';
import s from './Embed.scss';

const Embed = ({ content = {}, setup, selection = {} }) => {
	if (!content?.rawText) return null;
	let rawText = content.rawText;

	useEffect(() => {
		if (content.rawText.indexOf('JotFormIFrame-') !== -1) {
			addEvent(window, 'message.jotForm', (e) => {
				if (typeof e.data === 'object') return;
				const args = e.data.split(':');
				const [, jotFormId] = content.rawText.match(/JotFormIFrame-([0-9]+)/);
				const iframe = document.getElementById(`JotFormIFrame-${jotFormId}`);
				if (!iframe) return;
				switch (args[0]) {
					case 'scrollIntoView':
						iframe.scrollIntoView();
						break;
					case 'setHeight':
						iframe.style.height = `${parseInt(args[1], 10) + 72}px`;
						break;
					case 'collapseErrorPage':
						if (iframe.clientHeight > window.innerHeight) {
							iframe.style.height = `${window.innerHeight}px`;
						}
						break;
					case 'exitFullscreen':
						if (window.document.exitFullscreen) window.document.exitFullscreen();
						else if (window.document.mozCancelFullScreen) window.document.mozCancelFullScreen();
						else if (window.document.mozCancelFullscreen) window.document.mozCancelFullScreen();
						else if (window.document.webkitExitFullscreen) window.document.webkitExitFullscreen();
						else if (window.document.msExitFullscreen) window.document.msExitFullscreen();
						break;
					default:
						break;
				}
			});
		}

		return () => {
			removeEvent(window, 'message.jotForm');
			[...document.head.querySelectorAll('.js-embedScripts')].map((node) => node && node.remove());
		};
	}, [content.rawText]);

	let tradeLink;
	if (selection?.items) tradeLink = `https://www.emeco.net/selection/link${selection.items.reduce((acc, i) => `${acc}/${i.id.slice(i.id.lastIndexOf('/') + 1)}x${i.quantity}`, '')}${setup?.country ? `?country=${setup.country}` : ''}`;
	if (tradeLink) {
		rawText = rawText.replace(/src="[^"]*/, (match) => `${match}?checkoutLink=${encodeURIComponent(tradeLink)}`);
	}

	if (rawText.indexOf('zoho') !== -1) {
		return <ZohoForm setup={setup} htmlBlob={rawText} />;
	}

	return (
		<div className={[s.embed, 'js-embedScripts'].join(' ')} dangerouslySetInnerHTML={{ __html: purifier(rawText, { ADD_TAGS: ['iframe', 'script'], KEEP_CONTENT: false }, setup) }} />
	);
};

const mapState = ({ checkout }, props) => ({
	selection: checkout.selection,
	...props,
});

export default hot(module)(connect(mapState)(Embed));
